<template>
    <v-app light>
        <v-app-bar app :clipped-left="true" v-if="(isAuthenticated && showAppBar) || (!isAuthenticated && showAppBar)">
            <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <!-- <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->


            <!-- <v-btn icon @click.stop="miniVariant = !miniVariant">
                <v-icon v-if="miniVariant">mdi-chevron-right</v-icon>
                <v-icon v-else>mdi-chevron-left</v-icon>
            </v-btn> -->
            <v-toolbar-title>{{project}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn text @click="login_logout" class="d-none d-sm-flex">
                    <v-icon>mdi-account</v-icon>
                    <span>{{username? username + ' - logg ut' : 'logg inn'}}</span>
                </v-btn>
                <v-btn text @click="login_logout" class="d-flex d-sm-none">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-app-bar>
        <!-- <v-toolbar app :clipped-left="true" v-if="isAuthenticated">
            <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-btn icon @click.stop="miniVariant = !miniVariant">
                <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
            </v-btn>
            <v-toolbar-title>{{project}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat @click="login_logout">
                    <v-icon>person</v-icon>
                    <span>{{username? username + ' - logg ut' : 'logg inn'}}</span>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar> -->

        <v-navigation-drawer expand-on-hover mini-variant-width="75" :mini-variant="false" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed app v-if="(isAuthenticated && showNavDrawer) || (!isAuthenticated && showNavDrawer)">
        <!-- <v-navigation-drawer :permanent="$vuetify.breakpoint.lgAndUp" :mini-variant="false" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed app v-if="(isAuthenticated && showNavDrawer) || (!isAuthenticated && showNavDrawer)"> -->

            <v-treeview ref="tree" :items="items" hoverable activatable open-on-click return-object expand-icon="mdi-chevron-down" :active="[1]" @update:active="navigateTo">
                <template v-slot:prepend="{item}">
                    <v-icon>{{item.icon}}</v-icon>
                </template>
            </v-treeview>

        </v-navigation-drawer>

        <v-main>
            <router-view />
        </v-main>
        <v-footer :fixed="fixed" app class="body-2">
            <v-img max-height="32px" max-width="32px" src="./assets/norbotics-favicon.png"></v-img>
            <div class="mx-1"></div>
            <span> <span v-if="$vuetify.breakpoint.mdAndUp">Copyright</span> &copy; {{moment().year()}} Norbotics AS. <span v-if="$vuetify.breakpoint.mdAndUp">All Rights Reserved.</span></span>
            <!-- <v-btn text href="https://norbotics.no" target="_blank">
                <v-icon small>mdi-information</v-icon>Om oss
            </v-btn> -->
            <v-spacer></v-spacer>
            <v-icon @click="$store.dispatch('isVersionOk')">mdi-refresh-circle</v-icon>
            <div class="mx-1"></div>
            <div class="font-weight-bold">
                versjon: {{$store.getters.version ? $store.getters.version : '-'}}
            </div>
        </v-footer>

        <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" bottom right :color="snackbar.color">
            {{snackbar.text}}
            <v-btn text @click="snackbar.show = false" color="white">lukk</v-btn>
        </v-snackbar>

        <v-snackbar v-model="versionNotOk" color="error" top :timeout="-1" class="ma-0">
            <div class="d-flex" @click.stop="alertClicked" style="cursor: pointer;">
                <div>Ny versjon tilgjengelig. Klikk her for å oppdatere webapplikasjonen.</div>
                <v-icon right dark>mdi-refresh-circle</v-icon>
            </div>
        </v-snackbar>
    </v-app>
</template>

<script>
// import axios from "axios";
import { mapState } from 'vuex';

export default {
    name: "App",
    data() {
        return {
            // snackbar: {
            //     show: false,
            //     text: "",
            //     timeout: 7500,
            //     showLogout: function() {
            //         this.text = "Sesjonen din har utløpt - logg inn på nytt";
            //         this.show = true;
            //     },
            //     showInsufficientUserRights: function() {
            //         this.text = "Du har ikke tilstrekkelige brukerrettigheter";
            //         this.show = true;
            //     }
            // },
            alert: {
                show: true,
            },
            clipped: true,
            drawer: false,
            fixed: false,
            activeItems: [],
            items: [
                {
                    id: 1,
                    icon: "mdi-view-dashboard",
                    name: "Dashboard",
                    route: "/dashboard",
                    admin: false
                },
                {
                    id: 2,
                    icon: "mdi-truck",
                    name: "Leveranser",
                    route: "/delivery",
                    admin: false
                },
                {
                    id: 3,
                    icon: "mdi-calendar-today",
                    name: "Kalender",
                    route: "/calendar",
                    admin: false
                },
                {
                    id: 4,
                    icon: "mdi-map",
                    name: "Rigg og drift",
                    route: "/siteplan",
                    admin: false
                },
                {
                    id: 5,
                    icon: "mdi-map-marker",
                    name: "Soner",
                    route: "/zone",
                    admin: true
                },
                {
                    id: 6,
                    icon: "mdi-boom-gate",
                    name: "Porter",
                    // route: "/gate",
                    admin: false,
                    children: [
                        {
                            id: 7,
                            icon: "mdi-boom-gate",
                            name: "Porter",
                            route: "/gate",
                            admin: false
                        },
                        {
                            id: 8,
                            icon: "mdi-memory",
                            name: "Enheter",
                            route: "/unit",
                            admin: true
                        },
                        {
                            id: 9,
                            icon: "mdi-sim",
                            name: "Simkort",
                            route: "/simcard",
                            admin: true
                        }
                    ]
                },
                {
                    id: 10,
                    icon: "mdi-wrench",
                    name: "Ressurser",
                    route: "/resource",
                    admin: true
                },
                {
                    id: 11,
                    icon: "mdi-account-multiple-plus",
                    name: "Brukere",
                    admin: false,
                    // route: "/user"
                    children: [
                        {
                            id: 12,
                            icon: "mdi-account-multiple",
                            name: "Brukere",
                            route: "/user",
                            admin: false
                        },
                        {
                            id: 13,
                            icon: "mdi-domain",
                            name: "Bedrifter",
                            route: "/company",
                            admin: true
                        },
                        {
                            id: 19,
                            icon: "mdi-car-emergency",
                            name: "Etater",
                            route: "/agencies",
                            admin: true
                        }
                    ]
                },
                {
                    id: 14,
                    icon: "mdi-contacts",
                    name: "Leverandører",
                    route: "/supplier",
                    admin: true
                },
                {
                    id: 15,
                    icon: "mdi-cog",
                    name: "Innstillinger & admin",
                    // route: "/settings",
                    admin: true,
                    // new: true,
                    children: [
                        {
                            id: 16,
                            icon: "mdi-format-list-bulleted-square",
                            name: "Aktivitetslogg",
                            route: "/activityclaimed",
                            admin: true,
                            new: false
                        },
                        {
                            id: 17,
                            icon: "mdi-cog",
                            name: "Innstillinger",
                            route: "/settings",
                            admin: true
                        },
                        {
                            id: 18,
                            icon: "mdi-file-document-outline",
                            name: "Innhold",
                            route: "/content",
                            admin: true

                        }
                        // {
                        //     id: 18,
                        //     icon: "mdi-key",
                        //     name: "Nøkler",
                        //     route: "/keygenerator",
                        //     admin: true,
                        //     new: false
                        // }
                    ]
                }

                // {
                //     icon: "library_books",
                //     name: "Bruksanvisning",
                //     route: "/manual",
                //     admin: true
                // }
            ],
            miniVariant: false
        };
    },
    computed: {
        ...mapState({
            snackbar: "snackbar",
            versionOk: "versionOk"
        }),
        versionNotOk: function(){
            if(this.versionOk === undefined){
                return false;
            }

            return !this.versionOk;
        },
        username: function() {
            return this.$store.getters.username;
        },
        project: function() {
            return this.$store.getters.project;
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated;
        },
        isAdmin: function() {
            let rights = this.$store.getters.rights;
            if (typeof rights == "string") {
                return this.$store.getters.rights == "0";
            } else {
                return this.$store.getters.rights == 0;
            }
        },
        showAppBar: function() {
            return this.$store.getters.showAppBar;
        },
        showNavDrawer: function() {
            return this.$store.getters.showNavDrawer;
        }
    },
    methods: {
        navigateTo: function(items) {
            if (items && "length" in items && items.length == 1) {
                // console.log(items.map(i => i.name));
                this.routeTo(items[0].route);

                this.$refs.tree.updateAll(false);
            }
        },
        routeTo: function(route) {
            this.$router.push(route);
        },
        login_logout: function() {
            if (this.isAuthenticated) {
                this.$store.dispatch("logout");
            }
            this.routeTo("/login");
        },
        reloadWindow(){
            window.location.reload();
            // window.location.reload(clearCache);
        },
        alertClicked() {
            this.alert.show = false;
            this.$nextTick(() => {
                this.reloadWindow();
            });
        }
    },
    created() {
        this.$store.dispatch("isVersionOk");

        switch (this.$vuetify.breakpoint.name) {
            case "xs":
            case "sm":
                this.drawer = false;
                break;
            case "md":
            case "lg":
            case "xl":
                this.drawer = true;
                break;
        }

        var that = this;

        this.axios.interceptors.response.use(
            function(response) {
                let rights = response.headers["x-proxy-rights"];
                // console.log(rights == 0 ? 'admin' : 'user');
                that.$store.commit("rights", rights);
                return response;
            },
            function(error) {
                if (error.response.status == 401) {
                    // that.snackbar.show;
                    if (error && error.response && error.response.data && error.response.data.message) {
                        that.$store.dispatch("snackbar", { show: true, text: error.response.data.message, color: "error"});

                    } else {
                        that.$store.dispatch("snackbar", { show: true, text: "Sesjonen din har utløpt - logg inn på nytt.", color: "error"});
                    }

                    that.$store.dispatch("logout");
                    that.$router.push("/login");
                }

                if (error.response.status == 403) {
                    let user = error.response.data.user;
                    if (user) {
                        that.$store.commit("rights", user.rights);
                    }

                    that.$store.dispatch("snackbar", { show: true, text: "Mangler rettigheter.", color: "error"});

                    // that.$store.dispatch('logout');
                    // that.$router.push('/login');
                } else {
                    return Promise.reject(error);
                }
            }
        );
    }
};
</script>